import { useCallback, useEffect, useMemo, useState } from 'react'

export interface IUseLimitedListProps<T> {
  items: T
  limit?: number
  showMore?: boolean
  onShowAll?: () => void
}

/** Используется для вывода лимитированного списка с возможностью раскрыть его нажатием на кнопку */
export const useLimitedList = <T extends Record<string, any>[]>({
  showMore = true,
  items,
  limit = 0,
  onShowAll,
}: IUseLimitedListProps<T>): {
  limitedItems: T
  showAll: () => void
  countShowed: number
} => {
  const [countShowed, setCountShowed] = useState(limit)
  const limitedItems = useMemo(() => {
    return countShowed ? items.slice(0, countShowed) : items
  }, [items, countShowed, limit]) as T

  useEffect(() => {
    setCountShowed(limit)
  }, [limit])

  const showAll = useCallback(() => {
    if (showMore) setCountShowed(0)

    if (onShowAll) onShowAll()
  }, [onShowAll, showMore])

  return {
    limitedItems,
    showAll,
    countShowed,
  }
}
